import React from "react";
import Search from "@mui/icons-material/Search";
import ImportContacts from "@mui/icons-material/ImportContacts";
import { HumMenus } from "../../../type/componentsType/TkMenu";
import HelpOutline from "@mui/icons-material/HelpOutline";

export const standardMenu: HumMenus[] = [
  {
    name: "照会する",
    icon: <Search />,
    options: [
      {
        name: "代行者ホーム",
        path: "/SCRD310001",
      },
      {
        name: "退職者状況一覧",
        path: "/SCRC060031",
      },
    ],
  },
  {
    name: "お問い合わせ",
    icon: <HelpOutline />,
    options: [
      {
        name: "チャットボットに質問する",
      },
    ],
  },
];

export const staffAndPaymentProcedures: HumMenus[] = [];

export const facilitiesAndOtherProcedures: HumMenus[] = [
  {
    name: "その他のお手続き",
    icon: <ImportContacts />,
    options: [
      {
        name: "パスワード変更",
        path: "/SCRC010003",
        setBusinessType: "JOB-102",
      },
    ],
  },
];
